import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, catchError, of, mergeMap, switchMap } from 'rxjs';

import { IDjangoErrors } from '../../../models/DjangoErrors';
import { FileService } from '../../../services/file.service';
import { FileUiActions, FileApiActions } from '../actions/index';
import { IFile } from '../../../models/file';

@Injectable()
export class FileEffects {
  private actions$ = inject(Actions);
  private fileService = inject(FileService);

  getDraftFiles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileUiActions.GetDraftFiles),
      concatMap(() =>
        this.fileService.getDraftFiles().pipe(
          map((results: IFile[]) => FileApiActions.GetDraftFilesSuccess({ payload: results })),
          catchError((error) => of(FileApiActions.GetDraftFilesFailure({ errors: error as IDjangoErrors })))
        )
      )
    )
  );

  getFileDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileUiActions.GetFileDetail),
      switchMap(({ fileId }) =>
        this.fileService.getFileDetail(fileId).pipe(
          map((fileDetail) => FileApiActions.GetFileDetailSuccess({ fileDetail })),
          catchError((error) => of(FileApiActions.GetFileDetailFailure({ errors: error as IDjangoErrors })))
        )
      )
    )
  );

  deleteFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileUiActions.DeleteFile),
      mergeMap(({ fileId, request }) =>
        this.fileService.deleteFile(fileId, request).pipe(
          map(() => FileApiActions.DeleteFileSuccess({ fileId })),
          catchError((error) => of(FileApiActions.DeleteFileFailure({ errors: error as IDjangoErrors })))
        )
      )
    )
  );
}
